interface ScaleOptions {
  duration?: number;
  scale?: number;
  timing?: string;
}

export function scale(node: HTMLElement, options: ScaleOptions = {}) {
  const { duration = 150, scale = 1.02, timing = 'cubic-bezier(0.4, 0, 0.2, 1)' } = options;

  // Get the base scale from computed style (for container queries)
  function getBaseScale() {
    const transform = getComputedStyle(node).transform;
    if (transform === 'none') return 1;
    const matrix = new DOMMatrix(transform);
    return matrix.m11; // This gets the X scale factor
  }

  const existingTransition = getComputedStyle(node).transition;
  node.style.transition =
    existingTransition === 'none'
      ? `transform ${duration}ms ${timing}`
      : `${existingTransition}, transform ${duration}ms ${timing}`;

  let isAnimating = false;

  function handleMousedown() {
    if (!node.disabled && !isAnimating) {
      isAnimating = true;
      const baseScale = getBaseScale();
      node.style.transform = `scale(${baseScale * scale})`;

      // Force the animation to complete after duration
      setTimeout(() => {
        node.style.removeProperty('transform');
        setTimeout(() => {
          isAnimating = false;
        }, duration);
      }, duration);
    }
  }

  node.addEventListener('mousedown', handleMousedown);

  return {
    destroy() {
      node.removeEventListener('mousedown', handleMousedown);
    },
  };
}
